"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityTypeCode = exports.TokenAuthProvider = void 0;
const Loading_1 = __importDefault(require("@rahtab/system/src/screens/Loading"));
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const react_1 = __importStar(require("react"));
const AuthJSONClient_1 = __importDefault(require("./AuthJSONClient"));
const helpers_1 = require("./helpers");
const initialTokenAuthState = {
    roleVersion: 'single',
    aggreementIsSigned: false,
    isSignout: true,
    baseURL: '',
    setIsSignout: () => { },
    handleSuccessfulLogin: () => { },
    viewerEntityList: [],
    setViewerSelectedEntity: () => { },
    client: new AuthJSONClient_1.default(),
};
const TokenAuthContext = react_1.createContext(initialTokenAuthState);
const TokenAuthProvider = ({ baseURL, children, roleVersion = 'single', client, }) => {
    const [isSignout, setIsSignout] = react_1.useState(true);
    const [viewerEntityList, setViewerEntityList] = react_1.useState([]);
    const [initialLoading, setInitialLoading] = react_1.useState(true);
    const [aggreementIsSigned, setAggreementIsSigned] = react_1.useState(false);
    const viewerSelectedEntity = viewerEntityList.find((item) => item.selected);
    client.url =
        typeof baseURL === 'string' ? baseURL : baseURL[viewerSelectedEntity?.typeCode || EntityTypeCode.Provider];
    const handleSuccessfulLogin = async () => {
        const username = await helpers_1.getUsername();
        const _aggreementIsSigned = await async_storage_1.default.getItem(`${username}-Agreement`);
        setAggreementIsSigned(_aggreementIsSigned !== null);
        if (roleVersion === 'multi') {
            setViewerEntityList(await helpers_1.getViewerEntityList());
        }
        const result = await client.bootstrap();
        setIsSignout(result.isSignout);
    };
    react_1.useEffect(() => {
        (async () => {
            setInitialLoading(true);
            let authentication = await async_storage_1.default.getItem('sessionToken');
            const hasViewerEntityList = (await helpers_1.getViewerEntityList()).length > 0;
            if (authentication !== null && hasViewerEntityList) {
                await handleSuccessfulLogin();
            }
            setInitialLoading(false);
        })();
        const unsubscribe = client.on(AuthJSONClient_1.default.Events.UNAUTHENTICATED, () => {
            setIsSignout(true);
        });
        return unsubscribe;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    react_1.useEffect(() => {
        if (initialLoading)
            return;
        if (!isSignout)
            return;
        (async () => {
            setViewerEntityList([]);
            await client.clear();
            await helpers_1.setViewerEntityList([]);
            await helpers_1.removeUsername();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSignout, initialLoading]);
    return (react_1.default.createElement(TokenAuthContext.Provider, { value: {
            roleVersion,
            aggreementIsSigned,
            isSignout,
            baseURL: client.url,
            setIsSignout,
            handleSuccessfulLogin,
            viewerEntityList,
            viewerSelectedEntity,
            setViewerSelectedEntity: (value) => {
                helpers_1.setViewerEntityList(viewerEntityList.map((item) => ({ ...item, selected: item.typeCode === value })));
                setViewerEntityList(viewerEntityList.map((item) => ({ ...item, selected: item.typeCode === value })));
            },
            client,
        } }, initialLoading ? react_1.default.createElement(Loading_1.default, null) : children));
};
exports.TokenAuthProvider = TokenAuthProvider;
exports.default = TokenAuthContext;
var EntityTypeCode;
(function (EntityTypeCode) {
    EntityTypeCode[EntityTypeCode["Provider"] = 1] = "Provider";
    EntityTypeCode[EntityTypeCode["Middleman"] = 2] = "Middleman";
})(EntityTypeCode = exports.EntityTypeCode || (exports.EntityTypeCode = {}));
